module.exports = __webpack_public_path__ + "static/media/bodyIcons_hover.f6716e5c.svg";